import { render, staticRenderFns } from "./principleBranchTable.vue?vue&type=template&id=13a921bd&"
import script from "./principleBranchTable.vue?vue&type=script&lang=js&"
export * from "./principleBranchTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports